define('contentView',[
  'module',
  'marionette',
  'jquery',
  'underscore',
  'settings',
  'tawlkToBehavior',
  'rolesMixin',
  'headerView',
  'template!contentView'
], function (
  Module,
  Marionette,
  $,
  _,
  Settings,
  TawlkToBehavior,
  RolesMixin,
  HeaderView,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'content-view',

    regions: {
      headerRegion: '.header-region',
      sidebar: '#sidebar-region',
      content: '#content-region',
      orderRegion: '.orders-detail-region',
      zoom: '#gallery-zoom'
    },

    events: {
      'click @ui.backdrop': 'onSidebarShow',
      'click @ui.versionLabel': 'onVersionClick'
    },

    ui: {
      aside: '.aside-md',
      versionLabel: '.version-label',
      backdrop: '.sidebar-backdrop'
    },  

    behaviors: {
      SmartSupp: {
        behaviorClass: TawlkToBehavior,
        visible: true
      }
    },

    serializeData: function () {
      return {
        version: Settings.get('version'),
        bVersion: Settings.get('cAccountConfig').get('version')
      };
    },

    onShow: function() {
      this.headerView = new HeaderView();
      this.getRegion('headerRegion').show(this.headerView);
      this.applyDocumentationAffordance();
    },

    // The version label doubles as a shortcut to the end-user guide, but only
    // for users who hold the documentation role. When they do, show it as a
    // clickable link; otherwise leave it as a plain label.
    hasDocumentationRole: function () {
      var roles = Settings.get('cAccountRoles');
      if (!roles) {
        return false;
      }
      return roles[RolesMixin.DASHBOARD_DOCUMENTATION] === true;
    },

    applyDocumentationAffordance: function () {
      if (this.hasDocumentationRole()) {
        this.ui.versionLabel.css({cursor: 'pointer', color: '#337ab7', 'text-decoration': 'underline'});
        this.ui.versionLabel.attr('title', _.i18n('menu.documentation', null, 'Open the user guide'));
      }
    },

    onVersionClick: function () {
      if (!this.hasDocumentationRole()) {
        return;
      }
      window.open(Settings.url('compuzz2', 'v2/userguide'), '_blank');
    },

    onSidebarShow: function() {
      if (this.ui.aside.hasClass('nav-off-screen')) {
        this.ui.aside.removeClass('nav-off-screen');
        this.ui.backdrop.removeClass('visible');
      } else {
        this.ui.aside.addClass('nav-off-screen');
        this.ui.backdrop.addClass('visible');
      }
    },

    onResizeSidebar: function() {
      if (this.ui.aside.hasClass('nav-xs')) {
        this.ui.aside.removeClass('nav-xs');
        this.ui.versionLabel.show();
        this.storeSidebarCollapsed(false);
      } else {
        this.ui.aside.addClass('nav-xs');
        this.ui.versionLabel.hide();
        this.storeSidebarCollapsed(true);
      }
    },

    // Apply a known collapsed state (used when restoring the persisted
    // preference on boot), as opposed to onResizeSidebar which toggles.
    setSidebarCollapsed: function (collapsed) {
      this.ui.aside.toggleClass('nav-xs', collapsed);
      this.ui.versionLabel.toggle(!collapsed);
    },

    // Persist the icon-only ("simple icons") sidebar preference so it survives
    // reloads and account switches — the content/sidebar views are recreated
    // each time and would otherwise always start expanded.
    storeSidebarCollapsed: function (collapsed) {
      try {
        window.localStorage.setItem('compuzz-sidebar-collapsed', collapsed ? '1' : '0');
      } catch (e) { /* storage disabled / private mode — ignore */ }
    },

    onResizeWindow: function () {
      var width = $(document.body).width();

      if (width > 768) {
        this.ui.aside.removeClass('nav-off-screen');
        this.ui.backdrop.removeClass('visible');
      }
      if (width < 767) {
        this.ui.aside.removeClass('nav-xs');
      }
    }
  });
});
